/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserAssignedCommunications } from '../../models/user-assigned-communications';

export interface ApiTicketItemIdAssignedCommunicationsGet$Params {
  item_id: number;
}

export function apiTicketItemIdAssignedCommunicationsGet(http: HttpClient, rootUrl: string, params: ApiTicketItemIdAssignedCommunicationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAssignedCommunications>> {
  const rb = new RequestBuilder(rootUrl, apiTicketItemIdAssignedCommunicationsGet.PATH, 'get');
  if (params) {
    rb.path('item_id', params.item_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAssignedCommunications>;
    })
  );
}

apiTicketItemIdAssignedCommunicationsGet.PATH = '/api/ticket/{item_id}/assigned-communications';
